import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.DeleteExpenseReportPresenter`

export default defineMessages({
  confirmTitle: {
    id: `${scope}.confirmTitle`,
    defaultMessage: 'Delete expense report',
  },
  confirmMessage: {
    id: `${scope}.confirmMessage`,
    defaultMessage: 'Are you sure you want to delete this expense report?',
  },
  confirmButton: {
    id: `${scope}.confirmButton`,
    defaultMessage: 'Delete expense report',
  },
  deleteSuccess: {
    id: `${scope}.deleteSuccess`,
    defaultMessage: 'Expense report #{expenseId} deleted',
  },
  deleteError: {
    id: `${scope}.deleteError`,
    defaultMessage: "Expense report #{expenseId} couldn't be deleted",
  },
})
